export default "__VITE_ASSET__AF6wT7nC__"